export default {
  coming_soon: "Segera Akan Datang...",
  virtual_games: "Virtual",
  support: "Hubungi Kami",
  bet_limit: "Batas taruhan",
  favorites: "Favorit",
  note: "Catatan",
  my_bets: "Taruhan Saya",
  my_account: "Akun Saya",
  contact_us: "Hubungi Kami",
  report: "Melaporkan",
  help_support: "Bantuan & Dukungan",
  currency: "Mata Uangnya",
  others: "Lain",
  welcome: "Selamat Datang",
  account_id: "ID Akun",
  password: "kata sandi",
  account: "Rekening",
  all_sports: "Semua Olahraga",
  my_sports: "Olahraga",
  action: "Tindakan",
  accept_better_odds: "Terima Odds yang Lebih Baik",
  accept_any_odds: "Terima Odd Apa Saja",
  auto_refresh_odds: "Penyegaran Odd Otomatis",
  auto_refresh: "Refresh Otomatis",
  auto_refreshing: "Refresh Otomatis...",
  all_markets: "Semua Pasar",

  away: "Tim Tamu",

  all: "Semua",
  accepted: "Diterima",
  add_to_parlay: "Tambahkan ke Parlay",
  add_to_booster: "Add To Booster",
  amount: "Jumlah",
  amount_before_balance: "Jumlah Sebelum Saldo",
  amount_after_balance: "Jumlah Setelah Saldo",

  bet_slip: "Slip taruhan",
  bet_credit: "Kredit Taruhan",
  bet_list: "Daftar Taruhan",
  betting: "Bertaruh",
  balance: "Saldo",

  betting_statement: "Laporan Taruhan",
  bet_types: "Tipe Taruhan",
  bet_type: "Tipe Taruhan",
  bs: "B/S",
  bet_summary: "Bet Summary",
  bet_reject: "Taruhan Yang Gugur",
  bets: "Taruhan",
  bet: "Bertaruh",
  booster: "Boost",

  casino: "Kasino",
  mini_casino: "kasino mini",
  cash_balance: "Saldo tunai",
  change_account_password: "Ubah Kata Sandi Akun",
  current_password: "Kata sandi saat ini",
  confirm_new_password: "Konfirmasi Kata Sandi Baru",
  customize_sports_order: "Sesuaikan Urutan Olahraga",
  choice: "Pilihan",
  credit: "Kredit",
  commission: "Komisi",
  customize: "Kustomisasi",
  cancel: "Batal",
  confirmation: "Konfirmasi",
  closing_balance: "Saldo tertutup",
  clear_filter: "Clear Filter",

  debit: "Debit",
  display_language: "Tampilkan Bahasa",
  default_event_sorting: "Penyortiran Acara Default",
  default_stake: "Taruhan Default",
  date: "tanggal",
  draw: "Seri",
  draw_cancel: "Seri",
  dec: "Odds Desimal",
  double_line: "Spasi Ganda",
  disable: "nonaktifkan",
  dec_odds: "Odds Desimal",
  id_odds: "Odds Indo",
  double_chance: "Peluang Ganda",

  enable: "memungkinkan",
  event_sorting: "Event Sorting",
  edit: "Edit",
  early: "Awal",
  event: "Permainan",
  even: "Genap",

  first_goal: "Gol Pertama",
  first_half: "Skor Babak Pertama",
  final: "Skor Akhir",
  full_time: "Waktu Penuh",
  fold: "Fold",
  first_5_inn: "First 5 Innings",

  games: "Permainan",
  given_credit: "Kredit Yang Diberikan",
  group: "Group",
  goal: "Gol",

  half_time: "Babak 1",
  hide_header: "Sembunyikan Header",
  hk: "HK",
  hk_odds: "Hong Kong Odds",
  home: "Rumah",

  id: "ID",
  inactive: "Non-aktif",
  inplay: "In-Play",

  keno: "Keno",
  kickoff: "Permainan Dimulai",

  lottery: "Lotere",
  login: "Masuk",
  logout: "Keluar",
  last_login: "Login Terakhir",
  last_transaction: "Transaksi Terakhir",
  live_streaming: "Streaming Langsung",
  live_tv: "Streaming Langsung",
  live_match: "Pertandingan Langsung",
  live: "Live",
  live_center: "Pusat Langsung",
  livecasino: "Live Kasino",
  loss: "Kerugian",
  lost: "Kalah",
  lose: "Kalah",
  lose_half: "Kalah Separuh",
  last_bet: "Taruhan Terakhir",
  last_goal: "Gol Terakhir",

  mobile: "Ponsel",
  message: "Pesan",
  my_bet: "Taruhan Saya",
  my_favorites: "Favorit Saya",
  market_type: "Jenis Pasar",
  match: "Permainan",
  message_history: "Riwayat Pesan",
  my: "MY",
  market: "Pasar",
  main_markets: "Pasar Utama",
  my_odds: "Harga Melayu",
  min: "minimum",
  max: "maksimum",
  max_payout: "Bayaran Maksimum",
  main: "Utama",
  corners: "Tendangan Sudut/Kartu",
  specials: "Spesial",
  mix_parlay: "Taruhan Campuran",
  moneyline: "Money Line",

  no_goal: "Tidak Ada Gol",
  normal_announcements: "Pengumuman Normal",
  nickname: "Nama panggilan",
  new_password: "Kata Sandi Baru",
  new: "Baru",
  "no/": "No.",
  normal_sorting: "Penyortiran normal",

  other_markets: "Pasar Lain",
  outstanding: "Taruhan Berjalan",
  odds_type: "Tipe Odd",
  odds: "Harga",
  opening_balance: "Saldo awal",
  outright: "Outright",
  on: "HIDUP",
  off: "MATI",
  outstanding_bet: "Taruhan luar biasa",
  over: "Besar",
  odd: "Ganjil",
  hdp: "HDP",
  ou: "Besar/Kecil",
  oe: "Ganjil/Genap",
  oxt: "1X2",
  ml: "ML",

  password_expiry: "Kata sandi kedaluwarsa",
  parlay: "Parlay",
  page_display: "Tampilan Halaman",
  page_type: "Jenis Halaman",
  page_size: "Ukuran halaman",
  personal_message: "Pesan Pribadi",
  process_bet: "Proses Taruhan",
  payout: "Pembayaran",
  pending: "Tertunda",

  quick_bet: "Taruhan Cepat",
  quick_bet_stake: "Jumlah taruhan cepat",

  result: "Hasil",
  restore: "Restore",
  remark: "Keterangan",
  ref_no: "Ref No.",
  remove_from_parlay: "Remove Parlay",
  remove_from_booster: "Remove Booster",
  running: "Pertandingan",
  rules: "Peratutan",
  rules_regulations: "Peraturan & Ketetapan",

  sports: "Olahraga",
  show_balance: "Tampilan saldo",
  statement: "Laporan",
  settings: "Peraturan",
  search_team: "Cari Tim",
  show_header: "Tampilkan Header",
  submit: "Ajukan",
  set_nickname: "Atur Nama Panggilan",
  single: "Single",
  save: "Menyimpan",
  show_score_map: "Tampilkan Peta Skor",
  stake: "Taruhan",
  status: "Status",
  sort: "Menyortir",
  sportsbook: "Buku Olahraga",
  sum: "SUM",
  special_announcements: "Pengumuman Khusus",
  subtotal: "Subtotal",
  single_line: "Spasi tunggal",
  sort_by_time: "Sortir Menurut Waktu",
  slots: "Slots",
  mini_slots: "Slot Mini",
  select_leagues: "Pilih Liga",
  settled_amount: "Jumlah penyelesaian",

  turnover: "Omset",
  today: "Hari ini",
  time: "Waktu",
  team: "Tim",
  to: "Ke",
  trans_time: "Waktu Trans.",
  total: "Total Gol",
  total_goal: "Total Gol",
  treble: "Treble",
  transaction_date: "Tanggal Trans.",
  transfer_method: "Metode Transfer",
  transfer: "Transfer",

  under: "Kecil",
  void: "Batal",
  reject: "Menolak",
  rejected: "Menolak",
  valid_turnover: "Sah Omset",

  win: "Menang",
  won: "Menang",
  won_half: "Menang Separuh",
  waiting: "Menunggu",

  yes: "Ya",
  no: "Tidak",

  yesterday: "Kemarin",
  monday: "Senin",
  tuesday: "Selasa",
  wednesday: "Rabu",
  thursday: "Kamis",
  friday: "Jumat",
  saturday: "Sabtu",
  sunday: "Minggu",

  all_league: "Semua",
  match_completed: "Selesai",
  match_pending: "Hasil Tertunda",
  match_cancelled: "Penggantian Dana",
  match_cancelled_1h: "Penggantian Dana 1H",
  match_cancelled_2h: "Penggantian Dana 2H",
  match_suspended: "Abandoned",
  match_suspended_1h: "Abandoned 1H",
  match_suspended_2h: "Abandoned 2H",

  check_all: "Periksa Semua",
  selected_only: "Hanya yang Dipilih",
  filtered: "Tersaring",
  turn_on: "HIDUP",
  turn_off: "MATI",

  preference: "Preferensi saya",

  market_1: "Awal",
  market_2: "Hari ini",
  market_3: "In-Play",

  // Peraturan & Regulasi

  // asian_handicap: "Handicap Asia",
  // acceptance_countdown: "Penerimaan Timer Hitung Mundur",
  // acceptance_rules: "Penerimaan Ketentuan Umum dan Aturan Taruhan",
  // application_betting_rule: "Penerapan Aturan Taruhan Umum",
  // bettype_settlement_rule: "Aturan Penyelesaian Tipe Taruhan",
  // change_schedule: "Perubahan pada Waktu Terjadwal",
  // change_venue: "Perubahan Lokasi",
  // cons_interpret: "Konstruksi dan Penafsiran",
  // definition_of_term: "Definisi Istilah",
  // general_betting_rule: "Aturan Taruhan Umum",
  // general_terms: "Syarat dan Ketentuan Umum",
  // general_provision: "Ketentuan Umum",
  // general_rules_bt: "Aturan Umum Aturan Pasar (Jenis Taruhan)",
  // handicaps: "Handicap (HDP), Handicap Babak ke-1 & Handicap Babak ke-2",
  // running_bet_service: "LAYANAN TARUHAN BERJALAN (“LIVE”)",
  // limitation_provision: "Batasan Tanggung Jawab dan Ketentuan untuk Ganti Rugi",
  // match_duration: "Durasi Waktu",
  // member_account: "Akun Anggota",
  // mixparlays: "Taruhan Campuran",
  // mixparlay_payout: "Pembayaran Maksimum Mix Parlay",
  // over_unders: "Atas/Bawah (OU), Atas/Bawah Babak ke-1 & Atas/Bawah Babak ke-2",
  // odd_evens: "Ganjil/Genap (OE), Ganjil/Genap Babak ke-1 & Ganjil/Genap Babak ke-2",
  // rules_governing: "Aturan: Acara Umum dan Spesifik",
  // results: "Hasil",
  // software_game: "Perangkat Lunak dan Game",
  // single_team_oe: "Ganjil/Genap Satu Tim",
  // sport_betting_rule: "Aturan Taruhan Olahraga",
  // terms_of_transact: "Ketentuan Transaksi",
  // warranties: "Jaminan dan Pernyataan Anggota",

  american_football: "SEPAK BOLA AMERIKA",
  soccer: "SEPAK BOLA",
  basketball: "Bola Basket",
  baseball: "Bisbol",
  esports: "E-Sports",
  tennis: "TENIS",

  events: "Permainan",
  brackets: "Brackets",
  standing: "Standing",

  euro2020: "Kejuaraan Eropa UEFA 2020",

  play_now: "Main sekarang",

  processing: "Processing...",

  big_small: "Besar/Kecil",
  odd_even: "Ganjil/Genap",

  first_digit: "Digit 1",
  second_digit: "Digit 2",
  third_digit: "Digit 3",
  forth_digit: "Digit 4",
  total_4d: "Total 4D",
  total_3d: "Total Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",

  official_link: "Web Resmi",

  virtual_sports: "Olahraga maya",
  virtual_soccer: "Sepak Bola Maya",
  virtual_horse_racing: "Pacuan Kuda Maya",
  virtual_dog_racing: "Pacuan Anjing Maya",
  virtual_motorsport: "Balap Motor Maya",

  prize1: "1ST PRIZE",
  prize2: "2ND PRIZE",
  prize3: "3RD PRIZE",

  round1: "ROUND 1",
  round2: "ROUND 2",
  round3: "ROUND 3",
  round4: "ROUND 4",
  round5: "ROUND 5",

  map1: "MAP 1",
  map2: "MAP 2",
  map3: "MAP 3",
  map4: "MAP 4",
  map5: "MAP 5",
  map6: "MAP 6",
  map7: "MAP 7",
  map8: "MAP 8",
  map9: "MAP 9",
  map10: "MAP 10",
  score: "Skor",
  winner: "Pemenang",

  adjustment: "Pengaturan"
};
